import React from "react";

// Icon-badge stat tile — the core visual unit of the Agent Program design
// language (level/points/balance tiles, build-info tiles, etc). `tone` is a
// Tailwind bg+text pair, e.g. "bg-blue-50 text-blue-600".
export default function StatCard({ title, value, helper, icon: Icon, tone }) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 min-w-0">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider leading-tight">{title}</p>
          <p className="mt-2 text-lg font-semibold text-gray-900 break-words leading-tight">{value}</p>
          {helper && <p className="mt-1 text-xs text-gray-500 leading-snug">{helper}</p>}
        </div>
        {Icon && (
          <div className={`h-9 w-9 shrink-0 rounded-lg flex items-center justify-center ${tone || "bg-gray-100 text-gray-500"}`}>
            <Icon size={17} strokeWidth={2.2} />
          </div>
        )}
      </div>
    </div>
  );
}
